export default {"src":"/_next/static/media/sort-down-icon.19506fa4.svg","height":512,"width":513};